export const getDomainColor = ({ hero, color }) => {
  if (hero) {
    return hero.color;
  }
  if (color) {
    return color;
  }
  return undefined;
};

export const convertEstimationToRanking = (estimation, domains) => {
  const result = {};
  const values = domains.map(domain => estimation[domain]).sort();
  for (let i = 0; i < domains.length; i += 1) {
    const domain = domains[i];
    const value = estimation[domain];
    result[domain] = values.length - values.indexOf(value);
  }
  return result;
};

export const convertData = (estimations, fullDomains) => {
  if (!estimations) {
    return [];
  }
  let i = 20;
  const domains = fullDomains.map(domain => domain.slug);
  const result = [];
  // convert the values to ranking
  while (estimations[i]) {
    result.push({
      step: i,
      ...convertEstimationToRanking(estimations[i], domains),
    });

    i += 20;
  }
  result.push({
    step: 'all',
    ...convertEstimationToRanking(estimations.all, domains),
  });
  result.push();

  return result;
};

export const convertDataKey = (dataKey, domains) => {
  const foundDomain = domains.find(domain => domain.slug === dataKey);
  return foundDomain && foundDomain.hero ? foundDomain.hero.name : foundDomain.title;
};
